module.exports = __webpack_public_path__ + "img/whatson.23b3808a.jpg";